/* globals elkitorg_config  */

import { observable_component } from 'common/util/ComponentDecorator';
import CurrencyUtil from "common/util/CurrencyUtil";
import './checkout-shipping-method.scss';

@observable_component
export default class CheckoutShippingMethod {
	static classname = 'checkout-shipping-method';

	constructor($method) {
		this.$method = $method;
		this.shipping_id = $method.data('shipping_id');
		this.shipping_rates = $method.data('shipping_rates') || undefined;

		this.data_shipping_url = window.elkitorg_config.data_shipping_url;
		this.current_currency_info = window.elkitorg_config.currency_info[elkitorg_config.currency];
		this.hiding_comments = window.elkitorg_config.shipping_method_hiding_comments;

		this.initEventListeners();
		this.decorate();
		this.resetMethods();

		if (!this.isLoaded()) {
			const self = this;

			this.load().then(function () {
				self.updateRates();
				$method.removeClass('checkout-shipping-method_loading');
				self.resetMethods();
			}, function () {
				$method.removeClass('checkout-shipping-method_loading');
				self.resetMethods();
			});
		} else if (this.isChecked()) {
			const rate = this.getRate();
			this.$method.trigger('check@checkout-shipping-method', {
				rate: rate,
				name: this.getName()
			});
		}
	}

	decorate = () => {
		const $show_map_button = this.$method.find('.ShowMapButton');
		if ($show_map_button.length) {
			$show_map_button.clone().appendTo(this.$method.find('.checkout-shipping-method__rates-container'));
			$('.checkout-shipping-method__rates-container .ShowMapButton').on('click', function() {
				const $custom_show_map_button = $('.checkout-shipping-method__custom-container .ShowMapButton');
				$custom_show_map_button.trigger('click');
				$(this).html($custom_show_map_button.html());
			});
		}

		const formgroups = this.$method.find('.formgroup');
		if (formgroups.length) {
			formgroups.each(function() {
				const formgroup = $(this);
				const placeHolders = formgroup.find('.formgroup__placeholder');
				const inputs = formgroup.find('.formgroup__input');

				if (placeHolders.length) {
					placeHolders.each(function() {
						const placeHolder = $(this);
						if (placeHolder.text() === 'Адрес доставки') {
							formgroup.addClass('formgroup--required');
						}
					})
				}
				if (inputs.length) {
					inputs.each(function() {
						const input = $(this);
						if (input.hasClass('error') && input.attr('type') === 'text') {
							formgroup.addClass('formgroup--error');
						}
					})
				}
			});
		}
	};

	initEventListeners = () => {
		const self = this;

		self.$method.on('click', function() {
			const $this = $(this);
			if (self.isChecked()) {
				return;
			}

			$('.checkout-shipping-method').not(this).removeClass('checkout-shipping-method_checked');
			self.$method.addClass('checkout-shipping-method_checked');
			self.$method.find('.select').trigger('refreshWidth');

			const rate = self.getRate();

			self.$method.trigger('check@checkout-shipping-method', {
				rate: rate,
				name: self.getName()
			});
			$('input[name="shipping_id"]').trigger('change');
		});

		const $rates = self.getRatesSelect();
		$rates.on('change', function () {
			self.updateRate();
		});

		self.$method.on('change', '.checkout-shipping-method__content-container', function () {
			self.send().then(function () {
				self.updateRates();
			});
		});
	};

	isChecked = () => {
		return this.$method.hasClass('checkout-shipping-method_checked');
	};

	isHidden = () => {
		return this.$method.hasClass('checkout-shipping-method_error') || this.$method.hasClass('checkout-shipping-method_hidden');
	};

	resetMethods = () => {
		if (this.isChecked() && this.isHidden()) {
			$('.checkout-shipping').trigger('reset@checkout-shipping-methods');
		}
	};

	load = () => {
		const self = this;
		const deferred = $.Deferred();

		const request = $.ajax({
			url: self.data_shipping_url,
			data: {
				shipping_id: [self.shipping_id],
				html: true
			}
		});

		request.then(function (response) {
			if (typeof response.data[self.shipping_id] === 'string') {
				self.setError(response.data[self.shipping_id]);
				deferred.reject(response);

				return;
			}

			self.setError('');
			self.shipping_rates = response.data[self.shipping_id];
			self.handleShippingRates(self.shipping_rates);
			deferred.resolve(response);
		}, deferred.reject);

		return deferred;
	};

	send = () => {
		const self = this;
		const $form = self.$method.closest('form');

		const deferred = $.Deferred();

		const request = $.ajax({
			url: self.data_shipping_url,
			method: 'post',
			data: $form.serialize()
		});

		request.then(function (response) {
			if (typeof response.data === 'string') {
				self.setError(response.data);
				deferred.reject(response);
				return;
			}

			self.setError('');
			self.shipping_rates = response.data;
			self.handleShippingRates(self.shipping_rates);
			deferred.resolve(response);
		}, function () {
			this.$method.addClass('checkout-shipping-method_error');
			deferred.reject
		});

		return deferred;
	};

	updateRate = () => {
		const rate = this.getRate();

		if (!rate) {
			return;
		}

		this.setRate(rate.rate_html);
		this.setComment(rate.comment);
		this.setEstDelivery(rate.est_delivery);

		if (this.isChecked()) {
			this.$method.trigger('update_rate@checkout-shipping-method', {
				rate: rate,
				name: this.getName()
			});
		}

	};

	updateRates = () => {
		const $rates = this.getRatesSelect();
		$rates.empty();

		if (!this.shipping_rates) {
			return;
		}

		this.shipping_rates.forEach(function (rate) {
			const $option = $('<option></option>');
			$option.val(rate.id);
			$option.text(rate.name + ' (' + rate.rate + ')');
			$rates.append($option);
		});

		this.$method
			.find('.checkout-shipping-method__rates-container')
			.toggleClass('checkout-shipping-method__rates-container_multi', this.shipping_rates.length > 1);

		this.updateRate();
	};

	getRatesSelect = () => {
		return this.$method.find('select.checkout-shipping-method__rates');
	};

	getRate = () => {
		const $rates = this.getRatesSelect();

		if (!this.shipping_rates) {
			return null;
		}

		const rate = this.shipping_rates.find(function (rate) {
			return rate.id == $rates.val();
		});

		if (!rate) {
			return null;
		}

		return rate;
	};

	setRate = (rate) => {
		this.$method.find('.checkout-shipping-method__price-container').html(rate || '');
	};

	getName = () => {
		return this.$method.find('.checkout-shipping-method__name-container').html();
	};

	setComment = (comment) => {
		const $container = this.$method.find('.checkout-shipping-method__comment-container');
		$container.html(comment);
		$container.toggleClass('checkout-shipping-method__comment-container_empty', !comment);
		this.$method.removeClass('checkout-shipping-method_hidden');
		if (comment !== null) {
			const method = this.$method;
			$.each(this.hiding_comments, function (i, value) {
				if (comment.indexOf(value) >= 0) {
					method.addClass('checkout-shipping-method_hidden');
					return false;
				}
			});
		}
	};

	setEstDelivery = (est_delivery) => {
		const $container = this.$method.find('.checkout-shipping-method__est-delivery-container');
		const $est_delivery = $container.find('.checkout-shipping-method__est-delivery');
		const $deliveryDate = (est_delivery.replace(/ 2.\d+/g, '')).toLowerCase();
		$est_delivery.html($deliveryDate);
		$container.toggleClass('checkout-shipping-method__est-delivery-container_empty', !est_delivery);
	};

	setError = (error) => {
		const $container = this.$method.find('.checkout-shipping-method__error-container');
		$container.html(error);
		this.$method.toggleClass('checkout-shipping-method_error', error !== '');
		$container.toggleClass('checkout-shipping-method__error-container_empty', !error);
	};

	isLoaded = () => {
		return this.shipping_rates !== undefined
	};

	handleShippingRates = (shipping_rates) => {
		const self = this;

		shipping_rates.forEach(function (rate) {
			if (rate.rate === null) {
				rate.rate_raw = 0;
				return;
			} else if (!isNaN(rate.rate) || !rate.currency) {
				rate.rate_raw = rate.rate;
				return;
			}

			rate.rate_raw = CurrencyUtil.parse(rate.rate, self.current_currency_info, true);
		});
	};
};
